import { createSelector } from 'reselect';
import { getProjectsState } from '../../reducers';

export const selectProjects = createSelector(getProjectsState, (projects) => projects);
